import type { Block } from '../editor/types'

/**
 * Groups consecutive blocks into rows based on their `span` (1-3).
 * Each row holds blocks whose total span ≤ 3.
 * Blocks with span 3 (or no span = default full width) get their own row.
 */
export function groupBlockRows(blocks: Block[]): Block[][] {
  const rows: Block[][] = []
  let currentRow: Block[] = []
  let currentSpan = 0

  for (const block of blocks) {
    const span = block.span || 3
    if (currentSpan + span > 3) {
      if (currentRow.length > 0) rows.push(currentRow)
      currentRow = [block]
      currentSpan = span
    } else {
      currentRow.push(block)
      currentSpan += span
    }
    if (currentSpan >= 3) {
      rows.push(currentRow)
      currentRow = []
      currentSpan = 0
    }
  }
  if (currentRow.length > 0) rows.push(currentRow)
  return rows
}
